import { atom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';

export interface PinnedConversation {
  conversationId: string;
  order: number;
}

export const pinnedConversationsAtom = atomWithStorage<PinnedConversation[]>(
  'app.agent.pinned-conversations',
  [],
  undefined,
  { getOnInit: true },
);
pinnedConversationsAtom.debugLabel = 'pinnedConversations';

export const isConversationPinnedAtomFamily = atomFamily(
  (conversationId: string) =>
    atom(get => {
      const pinnedConversations = get(pinnedConversationsAtom);
      return pinnedConversations.some(
        pinnedConversation =>
          pinnedConversation.conversationId === conversationId,
      );
    }),
);

export const renamingConversationIdAtom = atom<string>();
